<template>
  <div class="card-info p-4">
    <img loading="lazy" :src="icons[icon]" :alt="title">
    <h5>{{ title }}</h5>
    <p class="m-0">{{ description }}</p>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import PorcineIcon from '@/assets/icons/porcine.svg'
import ProtectionIcon from '@/assets/icons/protection.svg'

export default defineComponent({
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    }
  },
  setup() {
    const icons = {
      porcine: PorcineIcon,
      protection: ProtectionIcon
    }

    return {
      icons
    }
  },
})
</script>

<style scoped>
  .card-info {
    background-color: #e4e7e4;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    text-align: center;
  }

  img {
    width: 60px;
  }
</style>
